var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { Card } from "../../components/modules/Card";
import { Text } from "../../components/elements/Text";
import { Button } from "../../components/elements/Button";
import CartooPasswordSuccessImage from "../../../images/cartoo-password-success.svg";
import { Container, Wrapper, ContentContainer, InfoContainer, CheckImage, } from "./styles";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { getHost123milhasUrl } from "../../utils/host123milhasUrl";
export function ResetPasswordSuccess() {
    var _a, _b;
    var location = useLocation();
    var _c = useContext(AuthContext), isFidelity = _c.isFidelity, handleCleanLoyaltyLocalStorage = _c.handleCleanLoyaltyLocalStorage;
    var loginRedirect = isFidelity
        ? "".concat((_a = process.env.MIX_HOST_FIDELIDADE_URL) === null || _a === void 0 ? void 0 : _a.replace(/\/$/, ""), "/auth/login")
        : "".concat((_b = getHost123milhasUrl()) === null || _b === void 0 ? void 0 : _b.replace(/\/$/, ""), "/login-sso");
    var handleLogin = function () {
        handleCleanLoyaltyLocalStorage();
        window.open(loginRedirect, "_self");
    };
    var state = location.state;
    if (state === null) {
        return _jsx(Navigate, { replace: true, to: "/senha/email" });
    }
    return (_jsx(Container, { children: _jsx(Wrapper, { children: _jsx(Card, { children: _jsx(ContentContainer, { children: _jsxs(InfoContainer, { children: [_jsx(CheckImage, { src: CartooPasswordSuccessImage, alt: "success" }), _jsx(Box, __assign({ marginBottom: "1rem" }, { children: _jsx(Text, __assign({ textStyle: "subtitle1", color: "fakeBlack" }, { children: "Sua nova senha foi criada com sucesso!" })) })), _jsx(Box, __assign({ marginBottom: "4rem" }, { children: _jsx(Text, __assign({ textStyle: "body1", color: "fakeBlack" }, { children: "Agora \u00E9 s\u00F3 fazer o login e aproveitar todas as ofertas 123milhas." })) })), _jsx(Button, { children: "FAZER LOGIN", colorScheme: "gradient", buttonVariant: "h2", onClick: function () { return handleLogin(); } })] }) }) }) }) }));
}
